<template>
  <div class="action-plan-form-item">
    <table class="action-plan-form-item__table">
      <tbody>
        <tr class="title">
          <!-- row 1 -->
          <td class="no-print">#{{ index }} ID {{ riskAnalysis.id }}</td>
          <td>AÇÕES</td>
          <td>IDENTIFICAÇÃO</td>
          <td>STATUS</td>
          <td>DESCRIÇÃO</td>
          <td>
            GRAU DE RISCO
            <span v-if="objectiveImprovements?.homologationReport?.file_url">
              {{ showOriginalDegree ? 'INICIAL' : 'ATUAL' }}
            </span>
            <a
              v-if="objectiveImprovements?.homologationReport?.file_url"
              @click="toggleDegree"
              style="cursor: pointer"
              class="no-print"
            >
              (MUDAR)
            </a>
          </td>
        </tr>

        <tr>
          <!-- row 2 -->

          <!-- ID -->
          <td rowspan="7" class="no-print">
            <div class="analysis-image">
              <img
                class="clickable"
                :src="riskAnalysis.picture_url"
                alt=""
                @click="showSingleImage(riskAnalysis.picture_url)"
              />
            </div>

            <div class="upload-title text-center font-size-1 font-weight-bold">
              Melhorias Objetivas
            </div>

            <div class="btn btn-success w-100 my-2" @click="showUploadPanel">
              Upload Melhoria Objetiva
            </div>

            <div class="upload-description text-center">
              Upload de Fotos ou Documentos evidenciando o Status atual da
              situação.
            </div>

            <div class="file-list mt-3">
              <div v-if="objectiveImprovementsFiles?.length === 0">
                Essa não conformidade ainda não tem nenhuma melhoria objetiva.
              </div>

              <div v-else>
                <div
                  class="file-list__item"
                  v-if="objectiveImprovements.budget"
                >
                  <div class="file-title">
                    Orçamento
                    <span style="color: orange">{{
                      !objectiveImprovements.budget?.file_url
                        ? ' (PENDENTE)'
                        : ''
                    }}</span>
                  </div>
                  <div class="file-name mt-1">
                    {{ objectiveImprovements.budget.file_name }}
                  </div>
                  <div class="file-options mt-1">
                    <a
                      class="file-options clickable mr-3"
                      target="_blank"
                      v-if="objectiveImprovements?.budget?.file_url"
                      @click="
                        showObjectiveImprovementImage(
                          objectiveImprovements?.budget?.file,
                        )
                      "
                      >Ver</a
                    >
                    <a
                      class="file-options clickable"
                      @click="onObjectiveImprovementFileDelete('budget')"
                      >Excluir</a
                    >
                  </div>
                </div>

                <div
                  class="file-list__item"
                  v-if="objectiveImprovements.adequacyProject"
                >
                  <div class="file-title">
                    Projeto Adequação
                    <span style="color: orange">{{
                      !objectiveImprovements.adequacyProject?.file_url
                        ? ' (PENDENTE)'
                        : ''
                    }}</span>
                  </div>
                  <div class="file-name mt-1">
                    {{ objectiveImprovements.adequacyProject.file_name }}
                  </div>
                  <div class="file-options mt-1">
                    <a
                      class="file-options clickable mr-3"
                      target="_blank"
                      v-if="objectiveImprovements?.adequacyProject?.file_url"
                      @click="
                        showObjectiveImprovementImage(
                          objectiveImprovements?.adequacyProject?.file,
                        )
                      "
                      >Ver</a
                    >
                    <a
                      class="file-options clickable"
                      @click="
                        onObjectiveImprovementFileDelete('adequacyProject')
                      "
                      >Excluir</a
                    >
                  </div>
                </div>

                <div
                  class="file-list__item"
                  v-if="objectiveImprovements.projectArt"
                >
                  <div class="file-title">
                    Art do Projeto
                    <span style="color: orange">{{
                      !objectiveImprovements.projectArt?.file_url
                        ? ' (PENDENTE)'
                        : ''
                    }}</span>
                  </div>
                  <div class="file-name mt-1">
                    {{ objectiveImprovements.projectArt.file_name }}
                  </div>
                  <div class="file-options mt-1">
                    <a
                      class="file-options clickable mr-3"
                      target="_blank"
                      v-if="objectiveImprovements?.projectArt?.file_url"
                      @click="
                        showObjectiveImprovementImage(
                          objectiveImprovements?.projectArt?.file,
                        )
                      "
                      >Ver</a
                    >
                    <a
                      class="file-options clickable"
                      @click="onObjectiveImprovementFileDelete('projectArt')"
                      >Excluir</a
                    >
                  </div>
                </div>

                <div
                  class="file-list__item"
                  v-if="objectiveImprovements.purchaseOrder"
                >
                  <div class="file-title">
                    Ordem de Compra
                    <span style="color: orange">{{
                      !objectiveImprovements.purchaseOrder?.file_url
                        ? ' (PENDENTE)'
                        : ''
                    }}</span>
                  </div>
                  <div class="file-name mt-1">
                    {{ objectiveImprovements.purchaseOrder.file_name }}
                  </div>
                  <div class="file-options mt-1">
                    <a
                      class="file-options clickable mr-3"
                      target="_blank"
                      v-if="objectiveImprovements?.purchaseOrder?.file_url"
                      @click="
                        showObjectiveImprovementImage(
                          objectiveImprovements?.purchaseOrder?.file,
                        )
                      "
                      >Ver</a
                    >
                    <a
                      class="file-options clickable"
                      @click="onObjectiveImprovementFileDelete('purchaseOrder')"
                      >Excluir</a
                    >
                  </div>
                </div>

                <div
                  class="file-list__item"
                  v-if="objectiveImprovements.finishedAdequacyPicture"
                >
                  <div class="file-title">
                    Foto Adequação Finalizada
                    <span style="color: orange">{{
                      !objectiveImprovements.finishedAdequacyPicture?.file_url
                        ? ' (PENDENTE)'
                        : ''
                    }}</span>
                  </div>
                  <div class="file-name mt-1">
                    {{
                      objectiveImprovements.finishedAdequacyPicture.file_name
                    }}
                  </div>
                  <div class="file-options mt-1">
                    <a
                      class="file-options clickable mr-3"
                      target="_blank"
                      v-if="
                        objectiveImprovements?.finishedAdequacyPicture?.file_url
                      "
                      @click="
                        showObjectiveImprovementImage(
                          objectiveImprovements?.finishedAdequacyPicture?.file,
                        )
                      "
                      >Ver</a
                    >
                    <a
                      class="file-options clickable"
                      @click="
                        onObjectiveImprovementFileDelete(
                          'finishedAdequacyPicture',
                        )
                      "
                      >Excluir</a
                    >
                  </div>
                </div>

                <div
                  class="file-list__item"
                  v-if="objectiveImprovements.homologationReport"
                >
                  <div class="file-title">
                    Laudo de Homologação
                    <span style="color: orange">{{
                      !objectiveImprovements.homologationReport?.file_url
                        ? ' (PENDENTE)'
                        : ''
                    }}</span>
                  </div>
                  <div class="file-name mt-1">
                    {{ objectiveImprovements.homologationReport.file_name }}
                  </div>
                  <div class="file-options mt-1">
                    <a
                      class="file-options clickable mr-3"
                      target="_blank"
                      v-if="objectiveImprovements?.homologationReport?.file_url"
                      @click="
                        showObjectiveImprovementImage(
                          objectiveImprovements?.homologationReport?.file,
                        )
                      "
                      >Ver</a
                    >
                    <a
                      class="file-options clickable"
                      @click="
                        onObjectiveImprovementFileDelete('homologationReport')
                      "
                      >Excluir</a
                    >
                  </div>
                </div>
              </div>
            </div>

            <button
              @click="showHistory(riskAnalysis.id)"
              class="btn btn-primary btn-sm mt-3"
            >
              Extrato de ações
            </button>
          </td>

          <!-- ACOES -->
          <td :rowspan="riskAnalysis.confined_space_entry ? '7' : '5'">
            <div class="row">
              <div class="col-10">
                <div class="form-group">
                  <label>Responsável Empresa / Frente</label>
                  <div class="d-flex align-items-center">
                    <AutoComplete
                      v-model="data.companyResponsible"
                      :dropdown="true"
                      :suggestions="filtered_work_fronts"
                      :disabled="data.workFrontId"
                      field="name"
                      class="w-100 mr-2"
                      @item-select="onWorkFrontSelect($event)"
                      @complete="filterWorkFronts($event)"
                    />
                    <button class="btn p-1 no-print" @click="unselectWorkFront">
                      <font-awesome-icon
                        :icon="['fas', 'times']"
                      ></font-awesome-icon>
                    </button>
                    <div class="no-print">
                      <router-link
                        :to="{
                          name: 'work-front',
                          params: { confinedSpaceId: data.id },
                        }"
                        target="_blank"
                      >
                        <label style="font-size: 14px; cursor: pointer">
                          Ver
                        </label>
                      </router-link>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>Responsável Terceiro</label>
                  <input
                    v-model="data.thirdPartyResponsible"
                    :disabled="data.workFrontId"
                    type="text"
                    class="form-control"
                  />
                </div>

                <div class="form-group">
                  <label>Supervisor Adequação</label>
                  <input
                    v-model="data.adequacySupervisor"
                    :disabled="data.workFrontId"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div
                class="
                  col-2
                  d-flex
                  align-items-center
                  justify-content-center
                  no-print
                "
              >
                <button
                  class="btn p-1"
                  v-tooltip="'Copiar campo para outras não conformidades'"
                  @click="copyFields"
                >
                  <font-awesome-icon
                    :icon="['fas', 'copy']"
                  ></font-awesome-icon>
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-10">
                <div class="form-group">
                  <label>Data Programada</label>
                  <Calendar
                    v-model="data.scheduledDate"
                    date-format="dd/mm/yy"
                    selection-mode="single"
                    :month-navigator="true"
                    :year-navigator="true"
                    year-range="2000:2100"
                    class="calendar-custom primevue-custom-field"
                  />
                </div>
              </div>
              <div
                class="
                  col-2
                  d-flex
                  align-items-center
                  justify-content-center
                  no-print
                "
              >
                <button
                  class="btn p-1"
                  v-tooltip="'Copiar campo para outras não conformidades'"
                  @click="copyFieldsDate"
                >
                  <font-awesome-icon
                    :icon="['fas', 'copy']"
                  ></font-awesome-icon>
                </button>
              </div>
            </div>

            <div class="form-group">
              <label>Média Orçamento</label>
              <InputNumber
                v-model="data.averageBudget"
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                class="currency-custom primevue-custom-field"
              />
            </div>

            <div class="form-group">
              <label>Data Realizada</label>
              <Calendar
                v-model="data.realizationDate"
                date-format="dd/mm/yy"
                selection-mode="single"
                :month-navigator="true"
                :year-navigator="true"
                year-range="2000:2100"
                class="calendar-custom primevue-custom-field"
              />
            </div>

            <div class="form-group">
              <label>Custo Real</label>
              <InputNumber
                v-model="data.realCost"
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                class="currency-custom primevue-custom-field"
              />
            </div>

            <div class="form-group">
              <label>Observação</label>
              <textarea
                v-model="data.observations"
                type="text"
                class="form-control"
                rows="3"
                style="height: auto"
              ></textarea>
            </div>
          </td>

          <!-- IDENTIFICACAO -->
          <td :rowspan="riskAnalysis.confined_space_entry ? '7' : '5'">
            <div class="form-group">
              <label>Nome E.C.</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="confined_space?.name || ''"
              />
            </div>

            <div class="form-group">
              <label>Tipo E.C.</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="confined_space?.confined_space_type?.name || ''"
              />
            </div>

            <div class="form-group">
              <label>Tag E.C.</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="confined_space?.confined_space_tag || ''"
              />
            </div>

            <div class="form-group">
              <label>Tag Ambra</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="confined_space?.ambra_tag || ''"
              />
            </div>

            <div class="form-group">
              <label>Setor</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="confined_space?.company_sector?.name || ''"
              />
            </div>

            <div class="form-group">
              <label>Área</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="confined_space?.company_area?.name || ''"
              />
            </div>

            <div class="form-group">
              <label>Complemento</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="confined_space?.company_complement?.name || ''"
              />
            </div>
          </td>

          <!-- STATUS -->
          <td rowspan="5">
            <vertical-stepper
              :steps="steps"
              :alerts="stepsWithProblems || []"
              :current-step="currentStep"
            ></vertical-stepper>
          </td>

          <!-- DESCRICAO -->
          <td>
            <!-- Descrição (Noncompliance) -->
            <span>{{
              riskAnalysis?.noncompliance_model?.description || ''
            }}</span>
          </td>

          <!-- GRAU DE RISCO -->
          <td
            v-if="!showOriginalDegree && riskAnalysis?.currentDegreeOfRisk"
            class="p-0 text-center align-middle"
            :style="{
              backgroundColor: getRiskColor(
                riskAnalysis?.currentDegreeOfRisk?.magnitude,
              ),
            }"
            :title="riskAnalysis?.currentDegreeOfRisk?.action"
          >
            <label class="font-weight-bold">
              {{ riskAnalysis?.currentDegreeOfRisk?.name }}
            </label>
          </td>
          <td
            v-else
            class="p-0 text-center align-middle"
            :style="{
              backgroundColor: getRiskColor(
                riskAnalysis?.degreeOfRisk?.magnitude,
              ),
            }"
            :title="riskAnalysis?.degreeOfRisk?.action"
          >
            <label class="font-weight-bold">
              {{ riskAnalysis?.degreeOfRisk?.name }}
            </label>
          </td>
        </tr>

        <tr class="title">
          <!-- row 3 -->
          <td>TRATATIVA</td>
          <td>AÇÕES E ESTRATÉGIAS</td>
        </tr>

        <tr>
          <!-- TRATATIVA -->
          <td>
            <span>
              {{ riskAnalysis?.noncompliance_model?.treatise }}
            </span>
          </td>

          <!-- ACOES E ESTRATEGIAS -->
          <td>
            <span>
              {{
                riskAnalysis?.noncompliance_model?.noncompliance_model_degree_of_risk?.action
                  .substring(0, 399)
                  .trim()
              }}...
            </span>
          </td>
        </tr>

        <tr class="title">
          <td v-if="riskAnalysis?.confined_space_entry">OBSERVAÇÃO</td>
          <td
            :colspan="isPrinting && !riskAnalysis?.confined_space_entry ? 2 : 1"
          >
            PENALIDADE MÁX. PREVISTA
          </td>
          <td v-if="!riskAnalysis?.confined_space_entry" class="no-print">
            OPÇÕES
          </td>
        </tr>

        <tr>
          <!-- OBSERVACAO -->
          <td v-if="riskAnalysis?.confined_space_entry">
            <span>
              {{
                riskAnalysis?.additional_observations?.substring(0, 300).trim()
              }}...
            </span>
          </td>

          <!-- PENALIDADE MAX. PREVISTA -->
          <td
            class="font-weight-bold text-center align-middle"
            :colspan="isPrinting && !riskAnalysis?.confined_space_entry ? 2 : 1"
          >
            <span style="font-size: 18px">
              R$ {{ riskAnalysis?.max_fine_value }}
            </span>
          </td>

          <!-- OPCOES -->
          <td
            v-if="!riskAnalysis?.confined_space_entry"
            class="text-center align-middle no-print"
          >
            <button @click="save()" class="btn btn-success">Salvar</button>
          </td>
        </tr>

        <tr class="title">
          <td v-if="riskAnalysis?.confined_space_entry">
            FORMATO DA BOCA DE VISITA
          </td>
          <td
            v-if="riskAnalysis?.confined_space_entry"
            :colspan="isPrinting ? 2 : 1"
          >
            MEDIDAS DA BOCA DE VISITA
          </td>
          <td v-if="riskAnalysis?.confined_space_entry" class="no-print">
            OPÇÕES
          </td>
        </tr>

        <tr>
          <!-- FORMATO DA BOCA DE VISITA -->
          <td
            class="text-center align-middle bv-icon"
            v-if="riskAnalysis?.confined_space_entry"
          >
            <font-awesome-icon
              :icon="[
                'fas',
                riskAnalysis?.confined_space_entry.format
                  ? 'circle'
                  : 'square-full',
              ]"
              size="6x"
            />
          </td>

          <!-- MEDIDAS DA BOCA DE VISISTA -->
          <td
            v-if="riskAnalysis?.confined_space_entry"
            :colspan="isPrinting ? 2 : 1"
            class="align-middle bv-measures-td"
          >
            <div class="form-group">
              <div
                class="bv-square-measures"
                v-if="!riskAnalysis?.confined_space_entry?.format"
              >
                <div class="form-group">
                  <label>Altura</label>
                  <input
                    type="text"
                    class="form-control"
                    readonly="true"
                    disabled="disabled"
                    :value="riskAnalysis?.confined_space_entry?.height || ''"
                  />
                </div>
                <div class="form-group">
                  <label>Largura</label>
                  <input
                    type="text"
                    class="form-control"
                    readonly="true"
                    disabled="disabled"
                    :value="riskAnalysis?.confined_space_entry?.width || ''"
                  />
                </div>
              </div>
              <div class="form-group" v-else>
                <label>Diâmetro</label>
                <input
                  type="text"
                  class="form-control"
                  readonly="true"
                  disabled="disabled"
                  :value="riskAnalysis?.confined_space_entry?.diameter || ''"
                />
              </div>
            </div>
          </td>

          <!-- OPCOES -->
          <td
            v-if="riskAnalysis?.confined_space_entry"
            class="text-center align-middle no-print"
          >
            <button @click="save()" class="btn btn-success no-print">
              Salvar
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="objective-improvements-inputs d-none">
      <input
        type="file"
        ref="budgetFile"
        @change="onObjectiveImprovementFileInput($event, 'budget')"
      />

      <input
        type="file"
        ref="adequacyProjectFile"
        @change="onObjectiveImprovementFileInput($event, 'adequacyProject')"
      />

      <input
        type="file"
        ref="projectArtFile"
        @change="onObjectiveImprovementFileInput($event, 'projectArt')"
      />

      <input
        type="file"
        ref="purchaseOrderFile"
        @change="onObjectiveImprovementFileInput($event, 'purchaseOrder')"
      />

      <input
        type="file"
        ref="finishedAdequacyPictureFile"
        @change="
          onObjectiveImprovementFileInput($event, 'finishedAdequacyPicture')
        "
      />

      <input
        type="file"
        ref="homologationReportFile"
        @change="onObjectiveImprovementFileInput($event, 'homologationReport')"
      />
    </div>

    <OverlayPanel
      :show-close-icon="true"
      :dismissable="true"
      ref="overlayPanel"
    >
      <div class="objective-improvements-upload-options">
        <div class="option-row option-row-1">
          <div class="option clickable" @click="$refs.budgetFile.click()">
            <div class="option__image">
              <img src="@/assets/images/melhoria-objetiva-1.png" alt="" />
            </div>
            <div class="option__title">Orçamento Cotação</div>
          </div>

          <div
            class="option clickable"
            @click="$refs.adequacyProjectFile.click()"
          >
            <div class="option__image">
              <img src="@/assets/images/melhoria-objetiva-2.png" alt="" />
            </div>
            <div class="option__title">Projeto Adequação</div>
          </div>

          <div class="option clickable" @click="$refs.projectArtFile.click()">
            <div class="option__image">
              <img src="@/assets/images/melhoria-objetiva-3.png" alt="" />
            </div>
            <div class="option__title">Art do Projeto</div>
          </div>
        </div>
        <div class="option-row option-row-2">
          <div
            class="option clickable"
            @click="$refs.purchaseOrderFile.click()"
          >
            <div class="option__image">
              <img src="@/assets/images/melhoria-objetiva-4.png" alt="" />
            </div>
            <div class="option__title">Ordem de Compra</div>
          </div>

          <div
            class="option clickable"
            @click="$refs.finishedAdequacyPictureFile.click()"
          >
            <div class="option__image">
              <img src="@/assets/images/melhoria-objetiva-5.png" alt="" />
            </div>
            <div class="option__title">Foto Adequação Finalizada</div>
          </div>

          <div
            class="option clickable"
            @click="$refs.homologationReportFile.click()"
          >
            <div class="option__image">
              <img src="@/assets/images/melhoria-objetiva-6.png" alt="" />
            </div>
            <div class="option__title">Laudo de Homologação</div>
          </div>
        </div>
      </div>
    </OverlayPanel>
  </div>
</template>

<script>
  import { computed } from 'vue'
  import { useStore } from 'vuex'

  import OverlayPanel from 'primevue/overlaypanel'
  import Calendar from 'primevue/calendar'
  import InputNumber from 'primevue/inputnumber'
  import AutoComplete from 'primevue/autocomplete'

  import VerticalStepper from './VerticalStepper'

  import useDegreeOfRisk from '@/modules/DegreeOfRiskUtil.js'
  import useImageViewer from '@/modules/ImageViewer.js'
  import useSwal from '@/modules/Swal.js'

  import { CONFINED_SPACE_RISKS } from '@/constants/images.constants.js'
  import * as ObjectiveImprovementTypesEnum from '@/constants/objective-improvement-type.constants.js'

  export default {
    setup() {
      const store = useStore()
      const selected_company = computed(() => store.getters.selected_company)

      const { getRiskColor } = useDegreeOfRisk()

      const { showSingleImage } = useImageViewer()

      const { showConfirmationDialog } = useSwal()
      const { showConfirmDeletionSwal } = useSwal()
      const { showSuccessDialog } = useSwal()

      return {
        selected_company,
        getRiskColor,
        CONFINED_SPACE_RISKS,
        showSingleImage,
        showConfirmationDialog,
        showConfirmDeletionSwal,
        showSuccessDialog,
      }
    },
    components: {
      AutoComplete,
      OverlayPanel,
      Calendar,
      InputNumber,
      VerticalStepper,
    },
    props: {
      riskAnalysis: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
      filters: {
        type: String,
        default: '',
        required: false,
      },
      workFronts: {
        type: Object,
        required: true,
      },
      isPrinting: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        currentStep: 0,
        showHrnResidualAnalysis: false,
        stepsWithProblems: [],
        steps: [
          'DELEGADO',
          'PROGRAMADO',
          'ORÇADO',
          'PROJETADO',
          'EM ADEQUAÇÃO',
          'CONCLUÍDO',
          'HOMOLOGADO',
        ],
        data: {
          workFrontId: null,
          companyResponsible: '',
          thirdPartyResponsible: '',
          adequacySupervisor: '',

          scheduledDate: '',

          ecommercePriceEnabled: false,

          averageBudget: null,
          realizationDate: '',
          realCost: null,
          observations: '',
        },
        confined_space: {
          confined_space_type: { name: '' },
          confined_space_tag: '',
          ambra_tag: '',
          name: '',
          company_sector: { name: '' },
          company_area: { name: '' },
          company_complement: { name: '' },
        },
        objectiveImprovements: {
          budget: null,
          adequacyProject: null,
          projectArt: null,
          purchaseOrder: null,
          finishedAdequacyPicture: null,
          homologationReport: null,
        },
        filtered_work_fronts: [],
        showOriginalDegree: false,
      }
    },
    emits: ['copy-all'],
    methods: {
      showHistory(id) {
        window.open(
          process.env.VUE_APP_API_URL + '/api/action-plan/history/' + id,
          'pagina',
          'width=850, height=355, top=100, left=110, scrollbars=no ',
        )
      },
      toggleHrnView(event) {
        event.stopPropagation()

        this.showHrnResidualAnalysis = !this.showHrnResidualAnalysis
      },
      showUploadPanel(event) {
        this.$refs.overlayPanel.toggle(event)
      },
      save() {
        let formData = new FormData()
        formData.append('risk_analysis_description_id', this.riskAnalysis.id)
        formData.append('budget', this.objectiveImprovements.budget)
        formData.append(
          'adequacyProject',
          this.objectiveImprovements.adequacyProject,
        )
        formData.append('projectArt', this.objectiveImprovements.projectArt)
        formData.append(
          'purchaseOrder',
          this.objectiveImprovements.purchaseOrder,
        )
        formData.append(
          'finishedAdequacyPicture',
          this.objectiveImprovements.finishedAdequacyPicture,
        )
        formData.append(
          'homologationReport',
          this.objectiveImprovements.homologationReport,
        )

        let putData = {
          rad: Object.assign({}, this.riskAnalysis),
          confined_space: Object.assign({}, this.confined_space),
          ...this.data,
          ...this.objectiveImprovements,
        }

        this.axios
          .put('/api/action-plan/update', putData)
          .then(() => {})
          .catch((e) => console.log(e))

        this.axios
          .post('/api/action-plan/update/files', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(({ data }) => {
            if (data[0].type === 5) {
              this.objectiveImprovements.finishedAdequacyPicture = data[0]
            }
            this.showSuccessDialog()
          })
          .catch((e) => console.log(e))
      },
      async showObjectiveImprovementImage(file) {
        let image = ''
        let fileName = ''

        await this.axios
          .get(`/api/action-plan/getObjectImprovementImage?file=${file}`)
          .then((data) => {
            image = data.data.b64
            fileName = data.data.fileName
          })
          .catch((e) => console.log(e))

        image = 'data:image/jpg;base64,' + image
        if (file.endsWith('.pdf')) {
          const downloadLink = document.createElement('a')
          downloadLink.href = image
          downloadLink.download = fileName
          downloadLink.click()
        } else {
          this.showSingleImage(image)
        }
      },
      onObjectiveImprovementFileInput(event, type) {
        const app = this

        const file = event.target.files[0]

        const map = {
          budget: () => {
            app.objectiveImprovements.budget = file
          },
          adequacyProject: () => {
            app.objectiveImprovements.adequacyProject = file
          },
          projectArt: () => {
            app.objectiveImprovements.projectArt = file
          },
          purchaseOrder: () => {
            app.objectiveImprovements.purchaseOrder = file
          },
          finishedAdequacyPicture: () => {
            app.objectiveImprovements.finishedAdequacyPicture = file
          },
          homologationReport: () => {
            app.objectiveImprovements.homologationReport = file
          },
        }

        if (Object.keys(map).includes(type)) map[type]()

        this.objectiveImprovement = { ...this.objectiveImprovement }
      },
      onObjectiveImprovementFileDelete(type) {
        const app = this

        const map = {
          budget: () => {
            this.showConfirmDeletionSwal().then((response) => {
              if (response.isConfirmed) {
                this.axios
                  .delete(
                    '/api/action-plan/remove/file/' +
                      app.objectiveImprovements.budget.id,
                  )
                  .then(() => (app.objectiveImprovements.budget = null))
              }
            })
          },
          adequacyProject: () => {
            this.showConfirmDeletionSwal().then((response) => {
              if (response.isConfirmed) {
                this.axios
                  .delete(
                    '/api/action-plan/remove/file/' +
                      app.objectiveImprovements.adequacyProject.id,
                  )
                  .then(
                    () => (app.objectiveImprovements.adequacyProject = null),
                  )
              }
            })
          },
          projectArt: () => {
            this.showConfirmDeletionSwal().then((response) => {
              if (response.isConfirmed) {
                this.axios
                  .delete(
                    '/api/action-plan/remove/file/' +
                      app.objectiveImprovements.projectArt.id,
                  )
                  .then(() => (app.objectiveImprovements.projectArt = null))
              }
            })
          },
          purchaseOrder: () => {
            this.showConfirmDeletionSwal().then((response) => {
              if (response.isConfirmed) {
                this.axios
                  .delete(
                    '/api/action-plan/remove/file/' +
                      app.objectiveImprovements.purchaseOrder.id,
                  )
                  .then(() => (app.objectiveImprovements.purchaseOrder = null))
              }
            })
          },
          finishedAdequacyPicture: () => {
            this.showConfirmDeletionSwal().then((response) => {
              if (response.isConfirmed) {
                this.axios
                  .delete(
                    '/api/action-plan/remove/file/' +
                      app.objectiveImprovements.finishedAdequacyPicture.id,
                  )
                  .then(
                    () =>
                      (app.objectiveImprovements.finishedAdequacyPicture =
                        null),
                  )
              }
            })
          },
          homologationReport: () => {
            this.showConfirmDeletionSwal().then((response) => {
              if (response.isConfirmed) {
                this.axios
                  .delete(
                    '/api/action-plan/remove/file/' +
                      app.objectiveImprovements.homologationReport.id,
                  )
                  .then(
                    () => (app.objectiveImprovements.homologationReport = null),
                  )
              }
            })
          },
        }

        if (Object.keys(map).includes(type)) map[type]()

        this.objectiveImprovement = { ...this.objectiveImprovement }
      },
      onWorkFrontSelect(event) {
        const work_front = event.value

        this.data.workFrontId = work_front.id
        this.data.companyResponsible = work_front.name
        this.data.thirdPartyResponsible =
          work_front.responsible_third_party.name
        this.data.adequacySupervisor = work_front.adequacy_supervisor.name
      },
      filterWorkFronts(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_work_fronts = [...this.workFronts]
          } else {
            this.filtered_work_fronts = this.workFronts.filter((work_front) => {
              return work_front.name
                .toLowerCase()
                .startsWith(event.query.toLowerCase())
            })
          }
        }, 250)
      },
      unselectWorkFront(event) {
        event.preventDefault()

        this.data.workFrontId = null
        this.data.companyResponsible = ''
        this.data.thirdPartyResponsible = ''
        this.data.adequacySupervisor = ''
      },
      setStep() {
        const app = this
        const lastStep = 7
        let stepsDone = []
        let stepsWithProblems = []

        //Each key is a step
        //Each value is a boolean; if true, the step is valid
        const validator = {
          1: (() => {
            return !!app.data.companyResponsible
          })(),

          2: (() => {
            return !!app.data.scheduledDate
          })(),

          3: (() => {
            return !!app.data.averageBudget
          })(),

          4: (() => {
            return !!app.objectiveImprovements.adequacyProject
          })(),

          5: (() => {
            return !!app.objectiveImprovements.projectArt
          })(),

          6: (() => {
            return !!app.objectiveImprovements.finishedAdequacyPicture
          })(),

          7: (() => {
            return !!app.objectiveImprovements.homologationReport
          })(),
        }

        //Loop through the validator;
        //If the step is valid, it's added to the stepsDone array
        //Add it to the stepsWithProblems array otherwise
        for (let step = 1; step <= lastStep; step++) {
          if (validator[step]) stepsDone.push(step)
          else stepsWithProblems.push(step)
        }

        //The current step is the last done step;
        const lastStepDone =
          stepsDone.length > 0 ? stepsDone[stepsDone.length - 1] : -1

        //To decide if a step has a problem, it has to be lower than the last done step.
        //Otherwise, steps that have not yet been filled, would be considered problematic, what is not true
        stepsWithProblems = stepsWithProblems.filter((p) => p < lastStepDone)

        this.currentStep = lastStepDone
        this.stepsWithProblems = [...stepsWithProblems]
      },
      copyFields() {
        this.showConfirmationDialog(
          'Certeza que deseja copiar este campo?',
          'Este campo será aplicado a todos os outros que sigam o preenchiento dos filtros',
          'warning',
        ).then((response) => {
          if (response) {
            this.axios.put(
              '/api/action-plan/update-all',
              this.filters + '&responsible=' + this.data.thirdPartyResponsible,
            )
          }
        })
      },
      copyFieldsDate() {
        this.showConfirmationDialog(
          'Certeza que deseja copiar este campo?',
          'Este campo será aplicado a todos os outros que sigam o preenchiento dos filtros',
          'warning',
        ).then((response) => {
          if (response) {
            let dater = new Date(Date.parse(this.data.scheduledDate))
            let dataFormatada =
              dater.getFullYear() +
              '-' +
              (dater.getMonth() + 1) +
              '-' +
              dater.getDate()

            console.log(dataFormatada)
            this.axios.put(
              '/api/action-plan/update-all-date',
              this.filters + '&scheduled_date=' + dataFormatada,
            )
          }
        })
      },
      mapDataToState() {
        this.fillBaseData()
        this.fillObjectiveImprovements()
      },
      fillBaseData() {
        let realizationDate, scheduledDate

        if (this.riskAnalysis.realization_date)
          realizationDate = new Date(this.riskAnalysis.realization_date)

        if (this.riskAnalysis.scheduled_date)
          scheduledDate = new Date(this.riskAnalysis.scheduled_date)

        this.data = {
          ...this.data,
          realizationDate: realizationDate || '',
          scheduledDate: scheduledDate || '',
          companyResponsible:
            this.riskAnalysis.work_front?.responsible ||
            this.riskAnalysis.company_responsible ||
            '',
          thirdPartyResponsible:
            this.riskAnalysis.work_front?.responsible_third_party ||
            this.riskAnalysis.third_party_responsible ||
            '',
          adequacySupervisor:
            this.riskAnalysis.work_front?.adequacy_supervisor ||
            this.riskAnalysis.adequacy_supervisor ||
            '',
          averageBudget: this.riskAnalysis.average_budget,
          realCost: this.riskAnalysis.real_cost,
          observations: this.riskAnalysis.observations,
        }

        if (this.riskAnalysis.work_front_id) {
          this.data.workFrontId = this.riskAnalysis.work_front_id
          this.data.companyResponsible = this.riskAnalysis.work_front.name
          this.data.thirdPartyResponsible = this.riskAnalysis.work_front
            .responsible_third_party
            ? this.riskAnalysis.work_front.responsible_third_party.name
            : null
          this.data.adequacySupervisor =
            this.riskAnalysis.work_front.adequacy_supervisor.name
        }
      },
      fillObjectiveImprovements() {
        const adequacies = this.riskAnalysis?.objective_improvements

        if (!adequacies) return

        let budget,
          adequacyProject,
          projectArt,
          purchaseOrder,
          finishedAdequacyPicture,
          homologationReport

        adequacies.forEach((adequacyItem) => {
          if (adequacyItem.type === ObjectiveImprovementTypesEnum.BUDGET) {
            budget = adequacyItem
          } else if (
            adequacyItem.type === ObjectiveImprovementTypesEnum.PROJECT_ADEQUACY
          ) {
            adequacyProject = adequacyItem
          } else if (
            adequacyItem.type === ObjectiveImprovementTypesEnum.PROJECT_ART
          ) {
            projectArt = adequacyItem
          } else if (
            adequacyItem.type === ObjectiveImprovementTypesEnum.PURCHASE_ORDER
          ) {
            purchaseOrder = adequacyItem
          } else if (
            adequacyItem.type ===
            ObjectiveImprovementTypesEnum.FINALIZED_ADEQUACY_PICTURE
          ) {
            finishedAdequacyPicture = adequacyItem
            this.showHrnResidualAnalysis = true
          } else if (
            adequacyItem.type ===
            ObjectiveImprovementTypesEnum.HOMOLOGATION_REPORT
          ) {
            homologationReport = adequacyItem
          }
        })

        this.objectiveImprovements = {
          budget,
          adequacyProject,
          projectArt,
          purchaseOrder,
          finishedAdequacyPicture,
          homologationReport,
        }
      },
      toggleDegree() {
        this.showOriginalDegree = !this.showOriginalDegree
      },
    },
    computed: {
      objectiveImprovementsFiles() {
        let files = []

        for (let f in this.objectiveImprovements) {
          if (this.objectiveImprovements[f])
            files.push(this.objectiveImprovements[f])
        }

        return files
      },
    },
    watch: {
      data: {
        handler() {
          this.setStep()
        },
        deep: true,
      },
      objectiveImprovements: {
        handler() {
          this.setStep()
        },
        deep: true,
      },
    },
    mounted() {
      this.confined_space = { ...(this?.riskAnalysis?.confined_space || {}) }

      this.mapDataToState()
    },
  }
</script>

<style lang="scss" scoped>
  .action-plan-form-item {
    &__table,
    .table-hrn,
    table {
      width: 100%;

      border-collapse: collapse;
      border-spacing: 0;

      .form-group {
        margin-bottom: 10px;
        display: block;

        label {
          display: block;
          margin: 0;
        }

        .form-control {
          height: 30px;

          font-size: 0.75rem;
        }
      }

      tr {
        td {
          width: 16.66666666666667%;
          padding: 10px;

          border-right: 1px solid #999;
          background-color: #ddd;

          text-align: left;
          vertical-align: top;

          font-size: 0.75rem;

          a {
            color: #337ab7;
          }
        }

        &.title,
        .table-title {
          td {
            background-color: #ccc;
            color: #626262;
            border-top: 1px solid #999;

            text-align: center;
            font-weight: bold;
            font-size: 12px;

            height: 30px;
            padding-top: 4px;
            padding-left: 5px;

            vertical-align: middle !important;
          }
        }
      }
    }

    .analysis-image {
      text-align: center;
      width: 100%;

      margin-bottom: 20px;

      img {
        width: 100%;
        height: auto;
        object-fit: cover;

        border-radius: 5px;
      }
    }

    .file-list {
      background-color: #fff;
      border-radius: 5px;
      padding: 10px;

      &__item {
        border-radius: 5px;
        background-color: #ccc;

        padding: 5px;

        &:not(:last-child) {
          margin-bottom: 5px;
        }

        .file-title {
          font-weight: bold;
        }

        .file-name {
          font-size: 0.6rem;
        }
      }
    }
  }

  .table-hrn {
    padding: 0 !important;

    tr,
    td {
      padding: 0 !important;
    }
  }

  .table-hrn tr:first-child td {
    border-top: none !important;
  }
  .table-hrn td:first-child {
    border-left: none !important;
  }
  .table-hrn td {
    border: 1px solid #aaa !important;
  }

  .primevue-custom-field {
    height: 30px;
    width: 100%;

    &::v-deep .p-inputtext {
      font-size: 0.75rem;
    }
  }
  .bv-square-measures {
    display: block;

    @media print {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
    }
  }

  @media print {
    td {
      font-size: 10px !important;

      bv-icon {
        font-size: 14px !important;
      }
    }
  }
</style>
